import axios from 'axios';

export const getProfil = async (navigate) => {
    try {
        const result = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/user/profil`, {
            withCredentials: true,
            validateStatus: () => true
        });
        if (!result.data.success && (result.data.error.code === 'NO_TOKEN' || result.data.error.code === 'INVALID_TOKEN')) {
            localStorage.removeItem('user');
            navigate('/login');
        }
        return result.data;
    } catch (_) {
        return {success: false, error: {code: "SERVER_ERROR", message: "Impossible de contacter le serveur"} };
    }
};

export const putProfil = async ({ email, number, firstname, name, traderCode, role, category, navigate }) => {
    try {
        const result = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/user/profil`,
            {email, number, firstname, name, traderCode, role, category }, {
            withCredentials: true,
            validateStatus: () => true
        });
        if (!result.data.success && (result.data.error.code === 'NO_TOKEN' || result.data.error.code === 'INVALID_TOKEN')) {
            localStorage.removeItem('user');
            navigate('/login');
        }
        return result.data;
    } catch (_) {
        return {success: false, error: {code: "SERVER_ERROR", message: "Impossible de contacter le serveur"} };
    }
};
